import React from 'react'

import { Editor } from '@tinymce/tinymce-react'

import './Seo.css'

class SeoPanel extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="seoPanel">
                <div className="row">
                    <div className="col-md-12">
                        <div className="user-blk header">
                            <p className="user-blk-hdg">Designer Page Information</p>

                            <div className="row child-row">
                                <div className="col-md-12">
                                    <p className="blk-label">Meta Data Title*:</p>
                                    <textarea className="seo" name="designerPageMetadataTitle" defaultValue={this.props.user.designerPageMetadataTitle} onChange={this.props.onSeoUpdate}/>
                                </div>
                                <div className="col-md-12">
                                    <p className="blk-label">URL*:</p>
                                    <textarea className="seo" name="designerPageUrl" defaultValue={this.props.user.designerPageUrl} onChange={this.props.onSeoUpdate}/>
                                </div>
                                <div className="col-md-12">
                                    <p className="blk-label">Meta Description*:</p>
                                    <textarea className="seo" name="designerPageMetadataDescription" defaultValue={this.props.user.designerPageMetadataDescription} onChange={this.props.onSeoUpdate}/>
                                </div>
                            </div>

                            <div className="row child-row">
                                <div className="col-md-4">
                                    <input type="checkbox" className="seo" name="designerPagePublished" defaultChecked={this.props.user.designerPagePublished} onChange={this.props.onSeoUpdate}/>
                                    <span className="blk-label">Published</span>
                                </div>
                                <div className="col-md-4">
                                    <p className="blk-label">Location*:</p>
                                    <select className="seo" name="designerLocationName" defaultValue={this.props.user.designerLocationName} onChange={this.props.onSeoUpdate}>
                                        <option>Select</option>
                                        {
                                            this.props.locations ?
                                                this.props.locations
                                                    .filter((loc) => { return loc.locationPagePublished })
                                                    .map((opt, index) => {
                                                        return <option value={opt.name} key={index}>{opt.name}</option>
                                                    })
                                            :
                                                null
                                        }
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <p className="blk-label">Phone:</p>
                                    <input type="text" className="seo" name="designerPhone" defaultValue={this.props.user.designerPhone} onChange={this.props.onSeoUpdate}/>
                                </div>
                            </div>

                            <div className="row child-row">
                                <div className="col-md-12">
                                    <p className="blk-label">Description*:</p>
                                    <Editor initialValue={this.props.user.designerDescription}
                                        init={
                                            {
                                                menubar: false,
                                                branding: false,
                                                elementpath: false,
                                                init_instance_callback: this.props.onPageDescChange,
                                                plugins: "lists advlist link image textcolor table hr code",
                                                toolbar: this.props.viewOnly ? false : "bold italic underline forecolor backcolor | styleselect numlist bullist | fontselect | fontsizeselect | link image | alignleft aligncenter alignright alignjustify | table hr code"
                                            }
                                        }
                                        apiKey="8e64hzacbayfd5osxbwkwtn1120t8xrh7wg526cs6ox73d3e"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SeoPanel